<template>
  <div class="topic">
    <div
      style="
        padding: 10px 10px;
        background: #ffffff;
        border-radius: 12px;
        margin-top: 10px;
      "
    >
      <div>
        <img
          src="http://img.zhujiaxian.com/2023/11/2dd49a7c5f1646caa8bca4687238f564.png"
          style="width: 100px; height: 25px"
          alt=""
        />
      </div>
      <div>
        <div>
          <div></div>
          <div class="localColor">
            <div>
              <img
                src="http://img.zhujiaxian.com/2023/03/2ad869836ca94ff9b39c66ed540a2a78.png"
                style="width: 100%; height: 135px"
                alt=""
                srcset=""
              />
            </div>
            <div style="overflow: hidden">
              <div class="whl-seckill-container">
                <van-swipe
                  class="whl-seckill-swiper"
                  :autoplay="3000"
                  :show-indicators="false"
                  loop
                >
                  <van-swipe-item
                    v-for="item in topicList"
                    :key="item.id"
                    style="width: 120px"
                  >
                    <div>
                      <div>
                        <div>
                          <img
                            style="width: 85px; height: 85px; margin-top: 10px"
                            :src="item.imgUrl"
                            alt=""
                          />
                        </div>
                        <div>
                          <div style="height: 50px;font-size: 14px;font-weight: bold;">
                            <p
                              style="
                                color: #907058;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ item.prodName }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </van-swipe-item>
                </van-swipe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <h3>{{ title }}</h3>
        <van-swipe class="my-swipe" :autoplay="1000" indicator-color="white">
            <van-swipe-item
                v-for="item in topicList"
                :key="item.id"
            >
                <img :src="item.imgUrl" alt="" />
                <p>{{ item.prodName }}</p>
                <p>{{ item.subtitle }}</p>
            </van-swipe-item>
        </van-swipe> -->
  </div>
</template>

<script>
export default {
  name: "topic",
  props: ["topicList", "title"],
};
</script>

<style lang="less" scoped>
.topic {
    margin:0px 10px;
}
</style>
